import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useDispatch } from 'react-redux';
// import { ReduxAction } from './../../constants';
import { ADD_CONTRACT } from './../../redux/actions';
import { persistDataStore } from './../../redux/persistStore';
import { PersistReduxAction } from './../../constants';
// Basic component with logout button
const LogoutButton = () => {
  const { oktaAuth } = useOktaAuth();
  const dispatch = useDispatch();
  const logout = () => {
    // FEATURE DISABLED (Release july-2026) - clearActivePersona
    // persistDataStore.dispatch({ type: PersistReduxAction.clearActivePersona });
    localStorage.clear();
    oktaAuth.signOut().then(() => {
      // dispatch({ type: ReduxAction.userInfoSet, payload: {} });
      dispatch({ type: ADD_CONTRACT, payload: {} });
      // clear session storage
      sessionStorage.clear();
    });
  };

  return (
    <div>
      <div
        id="logout_option"
        className="cursor-pointer"
        onClick={logout}
      >
        Logout
      </div>
    </div>
  );
};

export default LogoutButton;
